var BCSfAnalytics = {
    ANALYTICS_KEY: 'boostPFSAnalytics',
    SESSION_KEY: 'boostPFSSessionId',
    CART_TOKEN: '',
    SESSION: '',
    VIEWED_PRODUCT_DATA: null,
    init: function () {
      window.XMLHttpRequest &&
        bcsffilter &&
        bcSfFilterConfig &&
        ((BCSfAnalytics.CART_TOKEN = ''),
        (BCSfAnalytics.SESSION = BCSfAnalytics.getLocalStorage(
          BCSfAnalytics.SESSION_KEY
        )),
        BCSfAnalytics.SESSION ||
          ((BCSfAnalytics.SESSION = BCSfAnalytics.generateUUID()),
          BCSfAnalytics.setLocalStorage(
            BCSfAnalytics.SESSION_KEY,
            BCSfAnalytics.SESSION
          )),
        BCSfAnalytics.initSelector(),
        BCSfAnalytics.initInstantSearch(),
        BCSfAnalytics.initCollectionSearchPage(),
        BCSfAnalytics.initOtherPage());
    },
    initSelector: function () {
      (bcSfFilterConfig.general.product_id = ''),
        bcsffilter.selector.trackingProduct ||
          (bcsffilter.selector.trackingProduct = '#bc-sf-filter-products > *'),
        bcsffilter.selector.trackingQuickView ||
          (bcsffilter.selector.trackingQuickView = '.bc-quickview-btn-wrapper'),
        bcsffilter.selector.trackingAddToCart ||
          (bcsffilter.selector.trackingAddToCart =
            'form[action="/cart/add"] *[type="submit"], form[action="/cart/add"] *[name="add"]'),
        bcsffilter.selector.trackingBuyNow ||
          (bcsffilter.selector.trackingBuyNow =
            '.shopify-payment-button, #dynamic-checkout-cart');
    },
    initInstantSearch: function () {
      bcsffilter.getSettingValue('search.enableSuggestion') &&
        (document.addEventListener(
          'click',
          BCSfAnalytics.onClickProductInSuggestion,
          !0
        ),
        document.addEventListener(
          'keydown',
          BCSfAnalytics.onClickProductInSuggestion,
          !0
        ));
    },
    initCollectionSearchPage: function () {
      bcsffilter.selector.trackingProduct &&
        0 < jQ(bcsffilter.selector.products).length &&
        document.addEventListener(
          'click',
          BCSfAnalytics.onClickProductInFilterResult,
          !0
        );
    },
    initOtherPage: function () {
      var t;
      BCSfAnalytics.isProductPage()
        ? (bcsffilter.selector.trackingAddToCart &&
            0 < jQ(bcsffilter.selector.trackingAddToCart).length &&
            document.addEventListener(
              'click',
              BCSfAnalytics.onClickAddToCartInProductPage,
              !0
            ),
          bcsffilter.selector.trackingBuyNow &&
            0 < jQ(bcsffilter.selector.trackingBuyNow).length &&
            document.addEventListener(
              'click',
              BCSfAnalytics.onClickBuyNowInProductPage,
              !0
            ),
          jQ.ajax({
            type: 'GET',
            dataType: 'json',
            url: window.location.href.replace(/\/$/, '') + '.js',
            success: function (t) {
              bcSfFilterConfig.general.product_id = t.id;
              t = BCSfAnalytics.getLocalStorage(BCSfAnalytics.ANALYTICS_KEY);
              Array.isArray(t) &&
                t.forEach(function (t) {
                  BCSfAnalytics.sendProductClickData(t),
                    t.pid == bcSfFilterConfig.general.product_id &&
                      (BCSfAnalytics.VIEWED_PRODUCT_DATA = t);
                });
            },
          }))
        : ((t = BCSfAnalytics.getLocalStorage(BCSfAnalytics.ANALYTICS_KEY)),
          Array.isArray(t) &&
            t.forEach(function (t) {
              BCSfAnalytics.sendProductClickData(t);
            }));
    },
    refreshCartToken: function (c) {
      var e = new XMLHttpRequest();
      e.open('GET', '/cart.js'),
        (e.onload = function () {
          var t;
          3 < e.readyState &&
            200 == e.status &&
            ((t =
              (t = JSON.parse(e.responseText)).item_count <= 0 ? '' : t.token),
            (BCSfAnalytics.CART_TOKEN = t),
            c && ((c.ct = t), BCSfAnalytics.sendProductClickData(c, !0)));
        }),
        e.send();
    },
    generateUUID: function () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (t) {
          var c = (16 * Math.random()) | 0;
          return ('x' == t ? c : (3 & c) | 8).toString(16);
        }
      );
    },
    onClickProductInFilterResult: function (t) {
      var c, e, i;
      t &&
        t.target &&
        ((e = jQ(t.target)),
        (i = BCSfAnalytics.isSearchPage()
          ? BCSfAnalytics.AnalyticsEnum.Action.SEARCH
          : BCSfAnalytics.AnalyticsEnum.Action.FILTER),
        (c = BCSfAnalytics.AnalyticsEnum.UserAction.VIEW_PRODUCT),
        bcsffilter.selector.trackingAddToCart &&
          0 < e.closest(bcsffilter.selector.trackingAddToCart).length &&
          (c = BCSfAnalytics.AnalyticsEnum.UserAction.ADD_TO_CART),
        bcsffilter.selector.trackingBuyNow &&
          0 < e.closest(bcsffilter.selector.trackingBuyNow).length &&
          (c = BCSfAnalytics.AnalyticsEnum.UserAction.BUY_NOW),
        bcsffilter.selector.trackingQuickView &&
          0 < e.closest(bcsffilter.selector.trackingQuickView).length &&
          (c = BCSfAnalytics.AnalyticsEnum.UserAction.QUICK_VIEW),
        (t = ''),
        0 < (e = e.closest(bcsffilter.selector.trackingProduct)).length
          ? (t = BCSfAnalytics.getProductId(e))
          : BCSfAnalytics.VIEWED_PRODUCT_DATA &&
            ((c != BCSfAnalytics.AnalyticsEnum.UserAction.ADD_TO_CART &&
              c != BCSfAnalytics.AnalyticsEnum.UserAction.BUY_NOW) ||
              (t = BCSfAnalytics.VIEWED_PRODUCT_DATA.pid)),
        t &&
          ((i = BCSfAnalytics.buildProductClickData(t, c, i)),
          BCSfAnalytics.addProductClickData(i),
          BCSfAnalytics.sendProductClickData(i),
          c == BCSfAnalytics.AnalyticsEnum.UserAction.QUICK_VIEW
            ? (BCSfAnalytics.VIEWED_PRODUCT_DATA = i)
            : (BCSfAnalytics.VIEWED_PRODUCT_DATA = null)));
    },
    getProductId: function (t) {
      var c = t.attr('data-id'),
        e = t.find('.bc-sf-filter-product-script'),
        i = t.find("[href*='#data-bc-sf-product-id']");
      return (
        0 < i.length &&
          ((c = (t = i.attr('href')).split('#data-bc-sf-product-id=')[1]),
          i.attr('href', t.split('#')[0])),
        (c =
          !c && 0 < e.length
            ? (c = e.attr('data-id')) && c.replace('bc-product-json-', '')
            : c)
      );
    },
    onClickProductInSuggestion: function (t) {
      if (t && t.target && ('keydown' != t.type || 13 == t.keyCode)) {
        var c = null;
        if ('keydown' == t.type && 13 == t.keyCode) {
          var e = jQ(t.target).attr('id');
          if (!e || -1 == e.indexOf('bc-sf-search-box')) return;
          var c = jQ('ul[data-search-box="#' + e + '"]').find(
            '.' + bcsffilter.class.searchSuggestionItem + '-product.selected'
          );
        } else
          c = jQ(t.target).closest(
            '.' + bcsffilter.class.searchSuggestionItem + '-product'
          );
        !c ||
          0 == c.length ||
          ((c = BCSfAnalytics.getProductId(c)) &&
            ((c = BCSfAnalytics.buildProductClickData(
              c,
              BCSfAnalytics.AnalyticsEnum.UserAction.VIEW_PRODUCT,
              BCSfAnalytics.AnalyticsEnum.Action.SUGGEST
            )),
            BCSfAnalytics.addProductClickData(c)));
      }
    },
    onClickAddToCartInProductPage: function (t) {
      t &&
        t.target &&
        0 <
          jQ(t.target).closest(bcsffilter.selector.trackingAddToCart).length &&
        ((t = {
          tid: bcsffilter.shopDomain,
          pid: bcSfFilterConfig.general.product_id.toString(),
          u: BCSfAnalytics.AnalyticsEnum.UserAction.ADD_TO_CART,
          ct: BCSfAnalytics.CART_TOKEN,
        }),
        BCSfAnalytics.addProductClickData(t),
        BCSfAnalytics.sendProductClickData(t));
    },
    onClickBuyNowInProductPage: function (t) {
      t &&
        t.target &&
        0 < jQ(t.target).closest(bcsffilter.selector.trackingBuyNow).length &&
        ((t = {
          tid: bcsffilter.shopDomain,
          pid: bcSfFilterConfig.general.product_id.toString(),
          u: BCSfAnalytics.AnalyticsEnum.UserAction.BUY_NOW,
        }),
        BCSfAnalytics.addProductClickData(t),
        BCSfAnalytics.sendProductClickData(t));
    },
    buildProductClickData: function (t, c, e) {
      var i = new Date(),
        n = BCSfAnalytics.CART_TOKEN,
        a =
          c == BCSfAnalytics.AnalyticsEnum.UserAction.QUICK_VIEW
            ? BCSfAnalytics.AnalyticsEnum.UserAction.VIEW_PRODUCT
            : c,
        r = '';
      return (
        e == BCSfAnalytics.AnalyticsEnum.Action.FILTER
          ? (r += 'collection_scope=' + bcsffilter.collectionId)
          : (r += 'q=' + bcsffilter.currentTerm),
        (e != BCSfAnalytics.AnalyticsEnum.Action.FILTER &&
          e != BCSfAnalytics.AnalyticsEnum.Action.SEARCH) ||
          ((c = Object.keys(bcsffilter.queryParams).filter(function (t) {
            return t.startsWith(bcsffilter.prefix);
          })) &&
            0 < c.length &&
            c.forEach(function (c) {
              var t = bcsffilter.queryParams[c];
              Array.isArray(t)
                ? t.forEach(function (t) {
                    r += '&' + c + '=' + encodeURIComponent(t);
                  })
                : (r += '&' + c + '=' + encodeURIComponent(t));
            })),
        {
          tid: bcsffilter.shopDomain,
          ct: n,
          pid: t,
          t: i.toISOString(),
          u: a,
          a: e,
          qs: r,
          r: document.referrer,
        }
      );
    },
    addProductClickData: function (c) {
      var t = BCSfAnalytics.getLocalStorage(BCSfAnalytics.ANALYTICS_KEY),
        t = (t = !Array.isArray(t) ? [] : t).filter(function (t) {
          return t.pid != c.productId;
        });
      t.push(c), BCSfAnalytics.setLocalStorage(BCSfAnalytics.ANALYTICS_KEY, t);
    },
    removeProductClickData: function (c) {
      var t = BCSfAnalytics.getLocalStorage(BCSfAnalytics.ANALYTICS_KEY);
      Array.isArray(t) &&
        ((t = t.filter(function (t) {
          return t.pid != c;
        })),
        BCSfAnalytics.setLocalStorage(BCSfAnalytics.ANALYTICS_KEY, t));
    },
    getProductClickData: function (c) {
      var t = BCSfAnalytics.getLocalStorage(BCSfAnalytics.ANALYTICS_KEY);
      return Array.isArray(t)
        ? t.filter(function (t) {
            return t.pid == c;
          })
        : null;
    },
    getLocalStorage: function (t) {
      try {
        return JSON.parse(localStorage.getItem(t));
      } catch {
        return null;
      }
    },
    setLocalStorage: function (t, c) {
      try {
        null != c
          ? localStorage.setItem(t, JSON.stringify(c))
          : localStorage.setItem(t, '');
      } catch {}
    },
    sendProductClickData: function (t, c) {
      var e;
      c || t.ct
        ? ((t.sid = BCSfAnalytics.SESSION),
          (e = new XMLHttpRequest()).open(
            'POST',
            BCSfAnalytics.getApiUrl('analytics')
          ),
          e.setRequestHeader('Content-Type', 'application/json;charset=UTF-8'),
          (e.onload = function () {
            3 < e.readyState &&
              200 == e.status &&
              BCSfAnalytics.removeProductClickData(t.pid);
          }),
          e.send(JSON.stringify(t)))
        : setTimeout(function () {
            BCSfAnalytics.refreshCartToken(t);
          }, 1e3);
    },
    getApiUrl: function () {
      return bcSfFilterConfig.api.filterUrl.includes('services.mybcapps.com')
        ? 'https://lambda.mybcapps.com/e'
        : 'https://lajhlox2el.execute-api.us-west-2.amazonaws.com/staging/e';
    },
    AnalyticsEnum: {
      UserAction: {
        VIEW_PRODUCT: 'view_product',
        QUICK_VIEW: 'quick_view',
        ADD_TO_CART: 'add_to_cart',
        BUY_NOW: 'buy_now',
      },
      Action: { FILTER: 'filter', SEARCH: 'search', SUGGEST: 'suggest' },
    },
    isProductPage: function () {
      return -1 < window.location.pathname.indexOf('/products');
    },
    isSearchPage: function () {
      return window.location.href.includes('webcache.googleusercontent.com')
        ? -1 < window.location.search.indexOf('search?')
        : -1 < window.location.pathname.indexOf('/search');
    },
  },
  originalFilterCallback = BCSfFilterCallback;
BCSfFilterCallback = function (t) {
  originalFilterCallback(t), BCSfAnalytics.appendDataId();
};
var originalUrl = BCSfFilter.prototype.buildProductItemUrl;
(BCSfFilter.prototype.buildProductItemUrl = function (t) {
  var c = originalUrl.call(this, t);
  return -1 == c.indexOf('#') && (c += '#data-bc-sf-product-id=' + t.id), c;
}),
  (BCSfAnalytics.appendDataId = function () {
    setTimeout(function () {
      jQ("[href*='#data-bc-sf-product-id']").each(function (t, c) {
        var e = jQ(c),
          i = e.attr('href'),
          n = i.split('#data-bc-sf-product-id=')[1],
          c = e.closest(
            bcsffilter.selector.trackingProduct +
              ', .' +
              bcsffilter.selector.searchSuggestionItem +
              '-product'
          );
        0 < c.length && c.attr('data-id', n), e.attr('href', i.split('#')[0]);
      }),
        jQ("[data-bc-qv-template*='#data-bc-sf-product-id']").each(function (
          t,
          c
        ) {
          var e = jQ(c),
            c = (c = e.attr('data-bc-qv-template')).replace(
              /#data-bc-sf-product-id=[0-9]+/,
              ''
            );
          e.attr('data-bc-qv-template', c);
        });
    }, 500);
  }),
  BCSfAnalytics.init();
